import { Show } from "solid-js";
import type { VoidComponent } from "solid-js";
import { TextAndIconButton } from "../../../../components/button/Button.tsx";

type SettingSectionEditButtonProps = {
  editing: boolean;
  editLabel: string;
  setEditing: () => void;
};

const SettingSectionEditButton: VoidComponent<SettingSectionEditButtonProps> = (props) => (
  <Show when={!props.editing}>
    <TextAndIconButton
      class="ml-auto"
      text={props.editLabel}
      icon="pencil"
      variant="secondary"
      size="large"
      onClick={props.setEditing}
    />
  </Show>
);

export default SettingSectionEditButton;
